// extracted by mini-css-extract-plugin
export var label = "index-module--label--cETKo";
export var root = "index-module--root--ubF0f";